// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__25U_P","main":"Layout_main__1oCt-"};